import { createSlice } from '@reduxjs/toolkit'
import { logoutUser } from '../middlewares/logoutMiddleware'

const initialState = {
    openedCollapseIds: []
}

const referenceReasoningsSlice = createSlice({
    name: 'referenceReasonings',
    initialState,
    reducers: {
        toggleCollapsePanel: (state, action) => {
            const id = action.payload
            if (state.openedCollapseIds.includes(id)) {
                state.openedCollapseIds = state.openedCollapseIds.filter(panelId => panelId !== id)
            } else {
                state.openedCollapseIds.push(id)
            }
        },
        setOpenedCollapseIds: (state, action) => {
            state.openedCollapseIds = action.payload
        },
        reset: () => initialState
    },
    extraReducers: builder => builder.addCase(logoutUser, () => initialState)
})

export const referenceReasoningsActions = referenceReasoningsSlice.actions
export default referenceReasoningsSlice.reducer 